import type { ReactNode } from 'react';
import { ReturnArtifacts } from './ReturnArtifacts';
import { ItemDisplay } from './ItemDisplay';
import { Flex } from '@repo/ui/Flex';
import s from './Widgets.module.css';
import { LocationPreviewCard } from '../Locations/LocationPreviewCard';
import { formatLocationAddressSingle } from '../../utils/address';
import { hoursToString } from '../Locations/openingHours';
import type { WidgetProps } from './types';

export const Widget = ({
  context,
  label,
  orderItems,
  location,
  qrCode,
  deliveryMethod,
  status,
  pollingStatus,
}: WidgetProps) => {
  let widget: ReactNode = null;

  if (context === 'label' || context === 'printerless') {
    widget = (
      <ReturnArtifacts
        label={label}
        qrCode={qrCode}
        deliveryMethod={deliveryMethod}
        status={status}
        pollingStatus={pollingStatus}
      />
    );
  } else if (context === 'items' && orderItems && orderItems.length > 0) {
    widget = (
      <Flex className={s.itemsWrapper} padding="p-12" gap="g-12">
        <ItemDisplay items={orderItems} />
      </Flex>
    );
  } else if (context === 'location' && location) {
    widget = (
      <Flex className={s.locationWrapper} padding="p-12" gap="g-12">
        <LocationPreviewCard
          title={location.storeName}
          description={formatLocationAddressSingle(location.address)}
          icon={location.logoUrl}
          attribute={`${location.distance ?? ''}`}
          hours={hoursToString({
            locationHours: location.openingHours,
          })}
        />
      </Flex>
    );
  }
  return <div>{widget}</div>;
};
